import React, { useState, useEffect } from 'react';
import { useFormChangeHandler } from 'hooks/useFormChangeHandler';
import { useSubmitHandler } from 'hooks/useSubmitHandler';
import { useCreateData, useUpdateData } from 'hooks/useApiHooks';

const ChangeOrderDate = ({ initialData, onSuccess, onError }) => {
    const ORDER_URL = '/booking/edit-tanggal-booking';

    const [formData, setFormData] = useState({
        booking_id: initialData?.id || '',
        booking_date: initialData?.booking_date || '',
    });

    const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

    // API hook untuk create dan update
    const { createData, loading: creatingData } = useCreateData(`${ORDER_URL}`);

    // Gunakan hook untuk menangani perubahan form
    const handleChange = useFormChangeHandler(setFormData);

    // Gunakan hook untuk menangani pengiriman form
    const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
        createData,
        onSuccess,
        onError
    );

    useEffect(() => {
        // Jika data produk berubah (untuk update), isi ulang form data
        if (initialData) {
            setFormData({
                booking_id: initialData.id || '',
                booking_date: initialData.booking_date || '',
            });
        }
    }, [initialData]);

    const handleBeforeSubmit = (e) => {
        e.preventDefault();

        const payload = {
            booking_id: initialData.id,
            tanggal_booking: formData.booking_date,
        };

        handleSubmit(payload, e); // Submit the formatted payload
    };

    return (
        <div className='container-fluid mt-4'>
            <div className="card mb-4">
                <div className="card-body">
                    <form onSubmit={handleBeforeSubmit} className="d-flex flex-column">
                        <div className="form-group mb-3">
                            <label htmlFor="booking_date" className='mb-2'>Tanggal Booking</label>
                            <input
                                type="date"
                                className="form-control"
                                id="booking_date"
                                name="booking_date"
                                value={formData.booking_date}
                                onChange={handleChange}
                            />
                            {formError?.tanggal_booking && (<div className="text-danger mt-1">{formError.tanggal_booking}</div>)}
                        </div>



                        <div className="form-group d-grid">
                            <button type="submit" className="btn" disabled={isSubmitting}>
                                {isSubmitting ? 'Memproses...' : 'Simpan'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangeOrderDate;